exports.ByName = {
  MasterFile: {
    Name: 'MasterFile',
    VersionTable: 'master_file_report_version',
    ReportTable: 'master_file_report',
    FinalTable: 'master_file_report_final'
  },
  InternalFile: {
    Name: 'InternalFile',
    VersionTable: 'internal_localfile_report_instance',
    ReportTable: 'internal_localfile_report',
    TransactionsTable: 'internal_localfile_report_transaction',
    StatusTable: 'internal_localfile_report_instance_status'
  },
  Planning: {
    Name: 'Planning',
    VersionTable: 'planning_report_version',
    ReportTable: 'planning_report'
  }
};
